export default __webpack_public_path__ + "static/media/TickEnable.5c0081ad.svg";